export default function PractitionerFlowDiagram() {
    return (
        <div className="w-full bg-gradient-to-br from-slate-50 via-white to-gray-50">
            <svg viewBox="0 0 1000 550" className="w-full h-auto">
                <defs>
                    <marker id="arrowGray2" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
                        <path d="M0,0 L0,6 L9,3 z" fill="#9ca3af" />
                    </marker>
                    <marker id="arrowBlue2" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
                        <path d="M0,0 L0,6 L9,3 z" fill="#3b82f6" />
                    </marker>
                    <marker id="arrowGreen2" markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
                        <path d="M0,0 L0,6 L9,3 z" fill="#22c55e" />
                    </marker>
                </defs>

                {/* Retrieved the upcoming appointments text */}
                <text x="300" y="30" fontSize="10" fill="#6b7280">Retrieved the upcoming appointments.</text>

                {/* Practitioner Portal */}
                <rect x="30" y="220" width="120" height="40" rx="8" fill="#fbbf24" />
                <text x="90" y="245" textAnchor="middle" fontSize="11" fontWeight="600" fill="#1f2937">Practitioner Portal</text>

                {/* Practitioner Portal to Practitioner Login */}
                <line x1="150" y1="240" x2="190" y2="240" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray2)" />

                {/* Practitioner Login */}
                <rect x="200" y="220" width="130" height="40" rx="8" fill="#3b82f6" />
                <text x="265" y="245" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Practitioner Login</text>
                <text x="200" y="195" fontSize="9" fill="#6b7280">Practitioner can login with</text>
                <text x="200" y="205" fontSize="9" fill="#6b7280">Email, Password</text>

                {/* Login to BP APIs horizontal line */}
                <line x1="330" y1="240" x2="480" y2="240" stroke="#9ca3af" strokeWidth="2" />
                <text x="390" y="230" fontSize="9" fill="#6b7280" fontWeight="500">READ</text>

                {/* BP APIs */}
                <rect x="490" y="210" width="80" height="60" rx="8" fill="#ef4444" />
                <text x="530" y="245" textAnchor="middle" fontSize="12" fontWeight="700" fill="white">BP APIs</text>

                {/* Login up to Upcoming Appointments */}
                <path d="M 265 220 L 265 70 L 330 70" fill="none" stroke="#3b82f6" strokeWidth="2" markerEnd="url(#arrowBlue2)" />

                {/* Upcoming Appointments */}
                <rect x="340" y="50" width="110" height="45" rx="8" fill="#3b82f6" />
                <text x="395" y="68" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Upcoming</text>
                <text x="395" y="82" textAnchor="middle" fontSize="10" fontWeight="600" fill="white">Appointments</text>

                {/* Upcoming Appointments to BP APIs */}
                <path d="M 450 72 L 530 72 L 530 210" fill="none" stroke="#9ca3af" strokeWidth="2" />
                <text x="480" y="62" fontSize="9" fill="#6b7280" fontWeight="500">READ</text>

                {/* Retrieved the assigned patients text */}
                <text x="620" y="95" fontSize="10" fill="#6b7280">Retrieved the assigned patients</text>

                {/* BP APIs to Patients */}
                <path d="M 570 230 L 620 230 L 620 130 L 680 130" fill="none" stroke="#3b82f6" strokeWidth="2" markerEnd="url(#arrowBlue2)" />

                {/* Patients */}
                <rect x="690" y="110" width="100" height="40" rx="8" fill="#3b82f6" />
                <text x="740" y="135" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Patients</text>

                {/* Patients to AI Assistant */}
                <path d="M 790 125 L 830 125 L 830 180 L 860 180" fill="none" stroke="#22c55e" strokeWidth="2" markerEnd="url(#arrowGreen2)" />
                <text x="800" y="165" fontSize="9" fill="#6b7280" fontWeight="500">READ</text>

                {/* AI Assistant */}
                <rect x="870" y="160" width="100" height="40" rx="8" fill="#22c55e" />
                <text x="920" y="185" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">AI Assistant</text>
                <text x="870" y="145" fontSize="8" fill="#6b7280">Practitioner can summarize the pre-consultant summary</text>

                {/* Patients to Medical History */}
                <path d="M 790 135 L 830 135 L 830 240 L 860 240" fill="none" stroke="#22c55e" strokeWidth="2" markerEnd="url(#arrowGreen2)" />
                <text x="800" y="225" fontSize="9" fill="#6b7280" fontWeight="500">READ</text>

                {/* Medical History */}
                <rect x="870" y="220" width="110" height="40" rx="8" fill="#22c55e" />
                <text x="925" y="245" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Medical History</text>
                <text x="870" y="275" fontSize="8" fill="#6b7280">Practitioner can see the patient medical history</text>

                {/* Patients to Clinical Notes */}
                <path d="M 790 145 L 830 145 L 830 310 L 860 310" fill="none" stroke="#22c55e" strokeWidth="2" markerEnd="url(#arrowGreen2)" />
                <text x="795" y="300" fontSize="9" fill="#6b7280" fontWeight="500">READ/WRITE</text>

                {/* Clinical Notes */}
                <rect x="870" y="290" width="110" height="40" rx="8" fill="#22c55e" />
                <text x="925" y="315" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Clinical Notes</text>
                <text x="870" y="345" fontSize="8" fill="#6b7280">Practitioner can add/see the clinical notes</text>
                <text x="870" y="355" fontSize="8" fill="#6b7280">against the patient</text>

                {/* Login down to Check In/out */}
                <path d="M 265 260 L 265 350 L 400 350" fill="none" stroke="#9ca3af" strokeWidth="2" markerEnd="url(#arrowGray2)" />

                {/* Check In/out */}
                <rect x="410" y="330" width="100" height="40" rx="8" fill="#22c55e" />
                <text x="460" y="355" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Check In/out</text>
                <text x="410" y="385" fontSize="8" fill="#6b7280">Practitioner can see the</text>
                <text x="410" y="395" fontSize="8" fill="#6b7280">Patient clinic checked in and</text>
                <text x="410" y="405" fontSize="8" fill="#6b7280">add check in timer for their</text>
                <text x="410" y="415" fontSize="8" fill="#6b7280">appointment.</text>

                {/* Check In/out to BP APIs */}
                <path d="M 510 345 L 530 345 L 530 270" fill="none" stroke="#9ca3af" strokeWidth="2" />
                <text x="470" y="310" fontSize="9" fill="#6b7280" fontWeight="500">READ/WRITE</text>

                {/* Login down to Today's Scheduler */}
                <path d="M 265 260 L 265 450 L 330 450" fill="none" stroke="#3b82f6" strokeWidth="2" markerEnd="url(#arrowBlue2)" />

                {/* Today's Scheduler */}
                <rect x="340" y="430" width="120" height="40" rx="8" fill="#3b82f6" />
                <text x="400" y="455" textAnchor="middle" fontSize="11" fontWeight="600" fill="white">Today's Scheduler</text>

                {/* Legend */}
                <rect x="30" y="500" width="12" height="12" rx="2" fill="#fbbf24" />
                <text x="48" y="510" fontSize="9" fill="#6b7280">Entry Point</text>

                <rect x="120" y="500" width="12" height="12" rx="2" fill="#3b82f6" />
                <text x="138" y="510" fontSize="9" fill="#6b7280">Portal/Schedule</text>

                <rect x="230" y="500" width="12" height="12" rx="2" fill="#22c55e" />
                <text x="248" y="510" fontSize="9" fill="#6b7280">Feature</text>

                <rect x="310" y="500" width="12" height="12" rx="2" fill="#ef4444" />
                <text x="328" y="510" fontSize="9" fill="#6b7280">API</text>
            </svg>
        </div>
    );
}